<template>
  <entity-header-v2
    :icon="icon"
    :details="details"
  >
    <template #icon><slot name="icon" /></template>
    <slot />
  </entity-header-v2>
</template>

<script>
import EntityHeaderV2 from './EntityHeaderV2';

export default {
  name: 'entity-header',
  components: {
    EntityHeaderV2,
  },
  props: {
    icon: {
      type: String,
      required: false,
    },
    details: {
      type: String,
      required: false,
    },
  },
};
</script>
